import { lazy } from 'react'
import SuspenseSkeleton from '../../../../components/containers/SuspenseSkeleton';
import ApiDocVisor from './ApiDocVisor';
import "swagger-ui-react/swagger-ui.css"
import RouterBase from '../../../../components/navigation/RouterBase';
import { URLAPP } from '../../../../config';

const ApiDocArtifactAdmin = lazy(() => import('./ApiDocArtifactAdmin'));

export default function RestRouter() {
    return (
        <RouterBase
            items={[
                {
                    component: <SuspenseSkeleton itemLazy={<ApiDocArtifactAdmin />} />,
                    fullPath: URLAPP.apidocRestAdmin
                },
                {
                    component: <ApiDocVisor />,
                    fullPath: URLAPP.apidocRestDoc,
                    path: "documento/:apiId"
                }
            ]}
        />
    )
}
